<template>
    <div class="footer">
        <div class="content-footer">
            <div class="text-content fw500 fs15 pb8">레인보우 TV</div>
            <div class="text-content fs12 pb16">
                (주)씨엠비 대표자 이한담 <span class="text-content fs12 underline" @click="openFairTradeCommission">사업자등록번호 305-81-46536</span><br>
                우편번호 34830 대전광역시 중구 우암로 1<br>
                이메일 kangsinwan@cmb.co.kr
            </div>

            <div class="box-flex">
                <div class="text-content fs12 underline pb8" @click="goDetailTerm(1)">이용약관</div>&nbsp;
                <div class="text-content fs15 gray pb8">/</div>&nbsp;
                <div class="text-content fs15 blue underline pb8" @click="goDetailTerm(2)">개인정보처리방침</div>
            </div>
            <div class="text-content pb4">통신판매업 번호 제2010-대전중구-0048호</div>
            <div class="text-content pb4">CMB 대전방송, CMB 동대전방송, CMB 세종방송, CMB 충청방송, CMB 광주방송, CMB 광주동부방송, CMB 전남방송, CMB 대구방송, CMB 수성방송, CMB 영등포방송,
                CMB 동대문방송
            </div>
            <div class="text-content">[고객행복센터 ARS 안내] 대표전화: 1544-3434(유료/자사인터넷전화가입자 무료)
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: "PageFooter",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        goDetailTerm(data) {
            this.$router.push(`/mypage/terms`);
            setTimeout(() => {
                this.$router.push(`/mypage/terms/${data}`);
            }, 50)
        },
        openFairTradeCommission() { //
            window.open('https://www.ftc.go.kr/www/biz/bizCommList.do?key=5375', '_blank');
        },
    },
    watch: {},
}
</script>
<style lang="scss"></style>
